__turbopack_context__.v({
  "caretClosed": "FolderTreeBranch-module__hxyUTG__caretClosed",
  "caretIcon": "FolderTreeBranch-module__hxyUTG__caretIcon",
  "caretOpen": "FolderTreeBranch-module__hxyUTG__caretOpen",
  "chevronSpacer": "FolderTreeBranch-module__hxyUTG__chevronSpacer",
  "disabledFolderTreeNode": "FolderTreeBranch-module__hxyUTG__disabledFolderTreeNode",
  "disabledTitle": "FolderTreeBranch-module__hxyUTG__disabledTitle",
  "folderCheck": "FolderTreeBranch-module__hxyUTG__folderCheck",
  "folderMain": "FolderTreeBranch-module__hxyUTG__folderMain",
  "folderName": "FolderTreeBranch-module__hxyUTG__folderName",
  "folderOwnerAvatar": "FolderTreeBranch-module__hxyUTG__folderOwnerAvatar",
  "folderOwnerAvatarDisabled": "FolderTreeBranch-module__hxyUTG__folderOwnerAvatarDisabled",
  "folderTrailing": "FolderTreeBranch-module__hxyUTG__folderTrailing",
  "folderTreeGroup": "FolderTreeBranch-module__hxyUTG__folderTreeGroup",
  "folderTreeNode": "FolderTreeBranch-module__hxyUTG__folderTreeNode",
  "icon": "FolderTreeBranch-module__hxyUTG__icon",
  "selectedFolderTreeNode": "FolderTreeBranch-module__hxyUTG__selectedFolderTreeNode",
  "title": "FolderTreeBranch-module__hxyUTG__title",
  "trashButton": "FolderTreeBranch-module__hxyUTG__trashButton",
});
